(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.newsletter-popup__dialog');
      if (!this.dialog) return;

      this.storageKey = this.dataset.storageKey || 'marlowe-newsletter-popup';
      this.suppressDays = parseInt(this.dataset.suppressDays, 10) || 14;
      this.delay = parseInt(this.dataset.delay, 10) || 8000;
      this.exitIntent = this.dataset.exitIntent === 'true';
      this.opened = false;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.querySelector('[data-newsletter-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', this.handleBackdrop);
      this.dialog.addEventListener('close', this.handleDialogClose);

      const success = this.querySelector('[data-newsletter-success]');
      const error = this.querySelector('[data-newsletter-error]');

      // Server round-trip result: show immediately so the customer sees it.
      if (success || error) {
        if (success) this.suppress();
        this.open();
        return;
      }

      if (this.designMode) {
        // Preview inside the theme editor when the section is selected.
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.sectionId) this.open();
        });
        return;
      }

      if (this.isSuppressed()) return;

      this.timer = window.setTimeout(() => this.open(), this.delay);
      if (this.exitIntent) document.addEventListener('mouseout', this.handleExitIntent);
    }

    get sectionId() {
      const id = this.dialog.getAttribute('aria-labelledby') || '';
      return id.replace('NewsletterPopup-heading-', '');
    }

    isSuppressed() {
      try {
        const until = window.localStorage.getItem(this.storageKey);
        return until && Date.now() < parseInt(until, 10);
      } catch (e) {
        return false;
      }
    }

    suppress() {
      try {
        const until = Date.now() + this.suppressDays * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.storageKey, String(until));
      } catch (e) {
        /* localStorage unavailable — fail silent */
      }
    }

    open() {
      if (this.opened || !this.dialog || this.dialog.open) return;
      this.opened = true;
      this.cleanupTriggers();
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
      const input = this.querySelector('.newsletter-popup__input');
      if (input && !this.querySelector('[data-newsletter-success]')) {
        window.requestAnimationFrame(() => input.focus());
      }
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        this.dialog.close();
        return;
      }
      this.dialog.classList.add('newsletter-popup__dialog--closing');
      const done = () => {
        this.dialog.classList.remove('newsletter-popup__dialog--closing');
        this.dialog.removeEventListener('animationend', done);
        this.dialog.close();
      };
      this.dialog.addEventListener('animationend', done);
    }

    handleBackdrop = (event) => {
      if (event.target === this.dialog) this.close();
    };

    // Fires on ESC (native) and on programmatic close.
    handleDialogClose = () => {
      if (!this.designMode) this.suppress();
    };

    handleExitIntent = (event) => {
      if (event.clientY <= 0 && !event.relatedTarget) this.open();
    };

    cleanupTriggers() {
      window.clearTimeout(this.timer);
      document.removeEventListener('mouseout', this.handleExitIntent);
    }

    disconnectedCallback() {
      this.cleanupTriggers();
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
